import { render, staticRenderFns } from "./KBTabs.vue?vue&type=template&id=7fa9bb78&scoped=true&"
import script from "./KBTabs.vue?vue&type=script&lang=js&"
export * from "./KBTabs.vue?vue&type=script&lang=js&"
import style0 from "./KBTabs.vue?vue&type=style&index=0&id=7fa9bb78&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fa9bb78",
  null
  
)

export default component.exports